import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { addProductWithFrontStyle } from 'rangeConfig/shared/behaviors/addProductWithFrontStyle';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { matchBenchAssemblyToFrontsInScene } from 'rangeConfig/smastad/filters/mainMenuProductFilters';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import { furnitureSelected } from 'rangeConfig/smastad/rules/selectedRules';
import CeilingHeightInfoMessage from 'rangeConfig/smastad/widgets/CeilingHeightInfoMessage';
import { shouldDisableLoftBedProducts } from 'rangeConfig/smastad/utils/loftbed';

const furnituresProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  productFilters: [matchBenchAssemblyToFrontsInScene],
  selected: furnitureSelected,
  categories: [
    {
      id: 'benches',
      categoryTitle: 'typeName',
      products: [
        { path: 'type', value: ProductType.SMASTAD_BENCH },
        { path: 'type', value: ProductType.SMASTAD_BENCH_WITH_DRAWER_ASM }
      ]
    },
    {
      id: 'desk',
      categoryTitle: 'storageone.productListCategoryTitleDeskChangingTable',
      widgets: [
        {
          component: withInlineMessage(
            'storageone.smastadDeskChangingTableDescription',
            true,
            undefined,
            true
          )(CategoryAdditionalInlineMessage)
        }
      ],
      products: [
        { path: 'type', value: ProductType.SMASTAD_CHANGING_TABLE_W_DRAWERS_ASM },
        { path: 'type', value: ProductType.SMASTAD_DESK_W_DRAWERS_ASM }
      ]
    },
    {
      id: 'loft-bed',
      categoryTitle: 'typeName',
      widgets: [
        {
          component: withInlineMessage(
            'storageone.smastadLoftBedDescription1',
            true,
            undefined,
            true
          )(CategoryAdditionalInlineMessage),
          hidden: shouldDisableLoftBedProducts
        },
        {
          component: withInlineMessage(
            'storageone.smastadLoftBedDescription2',
            true,
            undefined,
            true
          )(CategoryAdditionalInlineMessage),
          hidden: shouldDisableLoftBedProducts
        },
        {
          component: CeilingHeightInfoMessage,
          hidden: (coreApi: CoreApi) => !shouldDisableLoftBedProducts(coreApi)
        }
      ],
      products: [{ path: 'type', value: ProductType.SMASTAD_LOFT_BED_ASM }],
      shouldDisableProducts: shouldDisableLoftBedProducts
    }
  ],
  behaviors: {
    productClicked: [addProductWithFrontStyle],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: [{ path: 'coreProductId', reverse: true }]
};

export default furnituresProductListConfig;
